<template>
    <v-row :class="className" no-gutters align="center">
        <template v-for="({ key, props, props_col = {} }, index) in items">
            <v-col :key="`${key}-divider`" v-if="index" cols="auto" class="px-8">
                -
            </v-col>
            <v-col :key="key" v-bind="props_col">
                <v-select
                    v-model="$data[key]"
                    v-bind="{
                        ...$attrs,
                        ...props,
                        disabled: !!index && !$data[items[index - 1].key],
                        appendIcon: null,
                    }"
                    @input="emit"
                />
            </v-col>
        </template>
    </v-row>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";

let getItems_y = () => {
    let items = [dayjs().year()];
    do {
        items.push(items.at(-1) - 1);
    } while (1900 < items.at(-1));

    return items.map((value) => ({ text: value?.toString().padStart(4, "0"), value }));
};

let getItems_m = () => {
    let items = new Array(12).fill("").map((_, index) => index + 1);

    return items.map((value) => ({ text: value?.toString().padStart(2, "0"), value }));
};

let getItems_d = ({ y, m }) => {
    if (!y || !m) return [];

    let end = dayjs();
    end = end.year(y);
    end = end.month(m - 1);
    end = end.endOf("month");
    end = end.date();

    let items = [1];

    do {
        items.push(items.at(-1) + 1);
    } while (items.at(-1) < end);

    return items.map((value) => ({ text: value?.toString().padStart(2, "0"), value }));
};

export default {
    props: {
        value: { type: String, default: null },
        className: { type: String, default: null },
    },
    data: () => ({
        y: null,
        m: null,
        d: null,
    }),
    mounted() {
        this.sync();
    },
    computed: {
        items() {
            return [
                {
                    key: "y",
                    props: {
                        placeholder: "연도",
                        items: getItems_y(),
                        suffix: this.y ? "년" : undefined,
                    },
                    // props_col: { cols: 5 },
                },
                {
                    key: "m",
                    props: {
                        placeholder: "월",
                        items: getItems_m(),
                        suffix: this.m ? "월" : undefined,
                    },
                    // props_col: { cols: 3 },
                },
                {
                    key: "d",
                    props: {
                        placeholder: "일",
                        items: getItems_d(this.$data),
                        suffix: this.d ? "일" : undefined,
                    },
                    // props_col: { cols: 3 },
                },
            ];
        },
        date() {
            return ["y", "m", "d"].reduce((date, key, index) => {
                if (date === null) return null;

                let value = this[key];
                if (!value) return null;

                if (!this.items[index].props.items.some((item) => item.value == value)) {
                    this.$nextTick(() => (this[key] = null));
                    return null;
                }

                switch (key) {
                    case "y": {
                        value = value.toString().padStart(4, "0");
                        date = `${value}`;
                        break;
                    }
                    default: {
                        value = value.toString().padStart(2, "0");
                        date += `-${value}`;
                        break;
                    }
                }

                return date;
            }, undefined);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            [this.y, this.m, this.d] = this.value?.split?.("-")?.map((value) => +value) || [this.y, this.m, this.d];
        },
        emit() {
            this.$emit("input", this.date);
        },
    },
};
</script>
<style lang="scss" scoped>
::v-deep {
    // .v-select__selections {
    //     justify-content: center;
    //     input {
    //         text-align: center;
    //     }
    //     input:nth-child(2) {
    //         display: none;
    //     }
    // }
    // .v-list-item__title {
    //     text-align: center;
    // }
}
</style>
